import { CanDeactivateFn, GuardResult, MaybeAsync } from '@angular/router';

/**
 * Sortie d'un écran avec des modifications non enregistrées : l'écran décide (canDeactivate), par exemple en demandant
 * confirmation (ui/modifications-en-cours.ts).
 */
export interface CanComponentDeactivate {
  canDeactivate: () => MaybeAsync<GuardResult>;
}

export const modificationsEnCoursGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
): MaybeAsync<GuardResult> => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
